import axios from "axios";
import { endpoints } from "../utils/endpoints";

export const getStateNames = async () => {
  const { data } = await axios.get(`${endpoints.general.getStateNames}`);
  return data.data || [];
};
